// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import Button from 'presentations/views/components/atoms/Button';
import { fontSize, mediaMax, spacing } from 'presentations/views/styles';
import { gray04, gray06, white } from 'presentations/views/styles/color';
import { ButtonGroup } from '@mui/material';

export type DateControllerChangeType = 'prev' | 'next' | 'today';

type Props = {
  isDisabledPrevButton: boolean;
  isDisabledTodayButton: boolean;
  isDisabledNextButton: boolean;
  handleChangeTerm: (action: DateControllerChangeType) => void;
};

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  return (
    <ButtonGroup size="small" aria-label="small outlined button group">
      <StyledButton
        onClick={() => props.handleChangeTerm('prev')}
        isDisabled={props.isDisabledPrevButton}
      >
        <StyledIcon name="chevron-left" />
      </StyledButton>
      <StyledTodayButton
        onClick={() => props.handleChangeTerm('today')}
        isDisabled={props.isDisabledTodayButton}
      >
        {t('Today')}
      </StyledTodayButton>
      <StyledButton
        onClick={() => props.handleChangeTerm('next')}
        isDisabled={props.isDisabledNextButton}
      >
        <StyledIcon name="chevron-right" />
      </StyledButton>
    </ButtonGroup>
  );
}

const StyledButton = styled(Button)`
  min-height: 32px;
  min-width: 32px;
  padding: 0px;
  font-weight: initial;
  border-color: ${gray04};

  ${mediaMax.tablet} {
    min-height: 28px;
    max-height: 28px;
    width: 27px;
  }

  height: 30px;
  min-height: 30px;
  min-width: 30px;
  border-color: ${white};
  background-color: ${gray06};
`;
const StyledTodayButton = styled(StyledButton)`
  min-width: initial;
  padding: ${spacing(3)} ${spacing(16)};

  ${mediaMax.tablet} {
    width: 60px;
  }
`;
const StyledIcon = styled(Icon)`
  font-size: ${fontSize(20)};
`;
